<template>
  <el-form
    v-if="metaData && metaData.panels"
    :key="formKey"
    ref="resumeForm"
    :model="form"
    :rules="rules"
    :class="`${prefixClass}-form demo-ruleForm`"
    label-width="100%"
    :size="formSize"
    enctype="multipart/form-data"
  >
    <div
      :class="`${prefixClass}-form__section ${section.panel_id}`"
      v-for="(section, i) in metaData.panels"
      :key="i"
    >
      <h4 v-if="section.lbl">{{ section.lbl }}</h4>

      <div v-for="(row, m) in section.rows" :key="`${i}_${m}`" class="flex-row">
        <div
          v-for="(item, k) in row"
          :key="`${i}_${m}_${k}`"
          :class="[fieldColumnClass(row, item, k)]"
        >
          <div
            v-if="item && item.type && item.name != 'photo'"
            class="no-margin"
          >
            <form-field
              :key="`${i}_${m}_${k}_${updateKey}`"
              :item="item"
              :form="form"
              :module="module"
              :form-size="formSize"
              :prefix-class="prefixClass"
              :field-loading="fieldLoading"
              :photo_file="photo_file"
              :options="newOptions"
              :blocked="blocked"
              :datepicker="datepicker"
              :callback="callback"
              :visible-option-btn="visibleSkillBtn"
              @set-value="setFieldValue"
              @add-new-option="addNewSkill"
              @change-option="changeOption"
              @save-form="saveForm"
            ></form-field>
          </div>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script>
import { Form } from 'element-ui';
import { store } from '@/store';
import { eventBus } from '@/bus';
import {
  mixin,
  form,
  metadata,
  saveForm,
  rules,
  parseIntent,
  dialogMixin
} from '@/utils/mixins';
import {
  MODULE,
  FIELD,
  DEFAULT_FORM_SIZE,
  EVENTBUS_EVENTS
} from '@/utils/constants';
import FormField from 'Elements/Form/FormField';

export default {
  mixins: [mixin, form, metadata, saveForm, rules, parseIntent, dialogMixin],
  props: {
    fields: {
      type: Object
    },
    metaData: {
      type: Object
    },
    id: {
      type: String,
      default: ''
    },
    candidateId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      prefixClass: 'candidate',
      FIELD,
      formSize: DEFAULT_FORM_SIZE,
      module: MODULE.HRPAC_CANDIDATES_RESUME,
      form: {},
      formKey: 0,
      options: {},
      rules: {},
      photo_file: [],
      resume_file: [],
      resume_loading: false,
      loading: false,
      visibleSkillBtn: false,
      callback: {
        field: {
          change: field => {
            switch (field.name) {
              case FIELD.ID.SKILLS_IDS:
                this.updateSkillOptions();
                break;

              default:
                break;
            }
          },
          input: (field, e) => {
            switch (field.name) {
              case FIELD.ID.SKILLS_IDS:
                this.handleChangeSkill(
                  e,
                  field.name,
                  field[FIELD.PARAM.MULTIPLE_LIMIT]
                );
                break;
              default:
                break;
            }
          },
          visibleChange: (field, bool) => {
            switch (field.name) {
              case FIELD.ID.SKILLS_IDS:
                this.handleBlur(bool, field.name);
                break;
              default:
                break;
            }
          }
        }
      },
      blocked: {},
      updateKey: 0,
      selectedContactsOption: null,
      skills: {}, // для новых навыков
      fieldLoading: false,
      counter: 0,
      tab: 'resume'
    };
  },
  computed: {
    datepicker() {
      return store.state.edit.datepicker;
    },
    skillsData() {
      return store.state.edit.vacancySkillsData;
    },
    is_visible() {
      return store.state.common.visible_dialog;
    },
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(value) {
        store.commit('common/setRequestState', value);
      }
    },
    recognisedForm() {
      return store.state.edit.recognisedForm;
    },
    newOptions() {
      return { ...this.options, ...store.state.common.newOptions };
    }
  },
  mounted() {
    this.processMetadata();

    if (this.recognisedForm) {
      this.form = { ...this.recognisedForm };
      this.updateKey++;
    }

    if (this.candidateId) {
      this.$set(this.form, 'candidate_id', this.candidateId);
    }
  },
  created() {
    eventBus.$on(EVENTBUS_EVENTS.SAVETAB, (val, tab, file) => {
      this.clickSaveForm(val, tab ? tab : null, file);
    });
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.SAVETAB);
  },
  methods: {
    async clickSaveForm(val, tab = null, file) {
      if (!tab || this.id == '1') {
        delete this.form.id;
      }
      try {
        let result = await this.saveForm('resumeForm', val);
        if (result) {
          eventBus.$emit(EVENTBUS_EVENTS.RELOAD_CANDIDATES_SUBPANEL, {
            val: val,
            tab: tab ? tab.name : null,
            updateSubpanel: this.id == '1' ? true : false,
            file: file
          });
        } else {
          store.commit('edit/setIntents', null);
        }
      } catch {
        store.commit('edit/setIntents', null);
      }
    },
    handleChangeSkill(val, name, limit) {
      if (limit && this.form[name].length === limit) {
        val = '';
        this.visibleSkillBtn = false;
      } else {
        const formatStr = str => str.toLowerCase().trim();
        const query = !store.state.common.newOptions[name].find(
          skill => formatStr(skill.name) === formatStr(val)
        );
        this.$set(this.skills, name, val);
        this.visibleSkillBtn = val ? query : false;
      }
    },
    handleBlur(visible, name) {
      if (!visible) {
        this.skills[name] = '';
        this.visibleSkillBtn = false;
      }
    },
    async addNewSkill(name) {
      const type = this.fields[name].front_field_type;

      if (this.skills[name] && this.skills[name].length) {
        if (!this.requestSent) {
          this.requestSent = true;

          this.fieldLoading = true;

          await store.dispatch('edit/addNewSkill', {
            name,
            skills: this.skills,
            type
          });

          this.fieldLoading = false;

          const skillsData = this.skillsData;

          if (Array.isArray(this.form[name])) {
            this.form[name].push(skillsData);
          } else {
            this.form[name] = [skillsData];
          }
          this.$refs.resumeForm.validateField(name);

          const newSkill = {
            id: skillsData,
            name: this.skills[name]
          };

          this.updateSkillOptions(newSkill);

          this.skills[name] = '';
          this.visibleSkillBtn = false;
          this.requestSent = false;
        }
      }
    },
    updateSkillOptions(newSkill) {
      if (
        newSkill &&
        typeof newSkill === 'object' &&
        !Array.isArray(newSkill)
      ) {
        this.options.skills_ids.push(newSkill);
      }
    }
  },
  components: {
    'el-form': Form,
    FormField
  }
};
</script>

<style lang="scss" scoped>
.candidate {
  overflow-x: hidden;
  width: 100%;
  max-width: 1392px;
  position: relative;
  overflow-y: auto;
  display: block;
  border-radius: 4px;

  &::-webkit-scrollbar {
    width: 0;
    display: none !important;
  }

  .candidate-form {
    background: $white;
    padding-bottom: 32px;

    .candidate-form__section {
      border-bottom: 1px solid $grey8;
      padding: 24px 0;

      .subpanel-block {
        display: flex;

        .subpanels {
          width: 100%;
          padding-right: 24px;
        }
      }
    }

    .candidate-form__upload-form {
      display: flex;
      gap: 24px;
      height: 190px;
      justify-content: space-between;

      & ::v-deep .photo-upload {
        position: relative;
        width: 144px;
        height: 190px;
      }
    }

    .candidate-form__resume-upload {
      width: calc(100% - 168px);
      height: 164px;

      & ::v-deep .el-upload-dragger {
        height: 164px;
      }

      & ::v-deep .el-upload__text {
        height: 164px;
      }
    }

    &::-webkit-scrollbar {
      width: 0px !important;
    }

    .el-form__section {
      text-align: left;

      h4 {
        color: $grey64;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        margin: 0;
        width: fit-content;
        padding: 0;
        margin-top: 0;
        margin-bottom: 16px;
      }

      .flex-row {
        justify-content: space-between;
        margin-bottom: 8px;

        & ::v-deep .el-form-item__label {
          display: contents;
          line-height: 24px !important;
          width: 100%;
          text-align: left !important;
        }

        .candidate-form__section-column {
          width: calc(50% - 16px);
        }

        .candidate-form__section-row {
          width: 100%;
        }

        .el-form-item__content {
          margin-left: 0 !important;
          width: 100%;
        }

        .el-form-item {
          margin-bottom: 0 !important;
          width: 100%;
          margin: 0 !important;
          min-height: 88px !important;

          .label {
            font-weight: normal;
            font-size: 14px;
            line-height: 24px;
            color: $black-200;
          }
        }

        &:last-child ::v-deep .el-form-item {
          margin-bottom: 0;
        }

        & ::v-deep .el-checkbox,
        & ::v-deep .el-radio {
          max-height: unset;
          height: 28px;
          align-items: center;
        }
      }
    }
  }
}

.el-form-item--hidden {
  display: none;
}

.no-margin {
  padding: 0;
  min-height: 88px;
  margin-left: 0;
  width: initial;

  .sub-fields {
    .el-form-item__content {
      display: flex;
    }
  }

  .el-form-item {
    margin: 0;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-form-item {
  width: 100% !important;

  &__error {
    top: initial;
  }
}
</style>
